import { GridColDef } from "@mui/x-data-grid";

export const cowColumns: GridColDef[] = [
    {
        headerName: 'Num Catalogue',
        field: 'Num_catalogue',
        type: 'string',
        flex: 5,
    },
    {
        headerName: 'Num Section',
        field: 'Num_section',
        type: 'string',
        flex: 1,
    },
    {
        headerName: 'Categorie',
        field: 'Categorie',
        type: 'string',
        flex: 1,
    },
    {
        headerName: 'Nom Court',
        field: 'Nom_court',
        type: 'string',
        flex: 1,
    },
    {
        headerName: 'Position Affixe',
        field: 'Position_affixe',
        type: 'string',
        flex: 1,

    },
    {
        headerName: 'Affixe',
        field: 'Affixe',
        type: 'string',
        flex: 1,
    },
    {
        headerName: 'Nom Long',
        field: 'Nom_long',
        type: 'string',
        flex: 10,
    },
    {
        headerName: 'Robe',
        field: 'Robe',
        type: 'string',
        flex: 1,
    },
    {
        headerName: 'Père',
        field: 'Pere',
        type: 'string',
        flex: 1,
    },
    {
        headerName: 'GPM',
        field: 'GPM',
        type: 'string',
        flex: 1,
    },
    {
        headerName: 'AGPM',
        field: 'AGPM',
        type: 'string',
        flex: 1,
    },
    {
        headerName: 'Date Naissance',
        field: 'Date_naissance',
        type: 'string',
        flex: 1,
    },
    {
        headerName: 'Rang Lact',
        field: 'Rang_lact',
        type: 'number',
        flex: 1,
    },
    {
        headerName: 'Propriétaires',
        field: 'Proprietaires',
        type: 'string',
        flex: 10,
    },
    {
        headerName: 'Dept Propriétaire',
        field: 'Dept_proprietaire',
        type: 'number',
        flex: 1,
    },
    {
        headerName: 'Naisseur',
        field: 'Naisseur',
        type: 'string',
        flex: 1,
    },
    {
        headerName: 'Dept Naisseur',
        field: 'Dept_naisseur',
        type: 'string',
        flex: 1,
    },
    {
        headerName: 'Num Lact',
        field: 'Num_lact',
        type: 'string',
        flex: 1,
    },
    {
        headerName: 'Lait',
        field: 'Lait',
        type: 'string',
        flex: 1,
    },
    {
        headerName: 'TA',
        field: 'TA',
        type: 'string',
        flex: 1,
    },
    {
        headerName: 'TB',
        field: 'TB',
        type: 'string',
        flex: 1,
    },
    {
        headerName: 'MU',
        field: 'MU',
        type: 'string',
        flex: 1,
    },
    {
        headerName: 'Note Globale',
        field: 'Note_globale',
        type: 'string',
        flex: 1,
    },
    {
        headerName: 'Version Table',
        field: 'Version_table',
        type: 'string',
        flex: 1,
    },
    {
        headerName: 'Age au Pointage',
        field: 'Age_au_pointage',
        type: 'string',
        flex: 1,
    }
]